import { TFunction } from 'i18next';
import { FeeType, QuickOrderAdditionalFee } from '../types';

export const calculateOrderTotals = ({ products, additionalFees }: { products: { pricePerUnit: string, quantity: string }[], additionalFees: Pick<QuickOrderAdditionalFee, 'id' | 'name' | 'price' | 'description' | 'type'>[] }) => {
	const subTotal = products.reduce((acc, product) => acc + Number(product.pricePerUnit) * Number(product.quantity), 0);
	const fixedFees = additionalFees.filter((fee) => fee.type === FeeType.Fixed);
	const fixedFeesTotal = fixedFees.reduce((acc, fee) => acc + Number(fee.price), 0) 
		+ subTotal;
	const calculatedFees = additionalFees
		.filter((fee) => fee.type === FeeType.Percentage)
		.map((fee) => {
			return { ...fee, sum: (fixedFeesTotal * Number(fee.price) / 100).toFixed(2) };
		});
	const calculatedFeesTotal = calculatedFees.reduce((acc, fee) => acc + Number(fee.sum), 0);
	const total = Math.round((fixedFeesTotal + calculatedFeesTotal) * 100) / 100;
	return { subTotal, fixedFees, calculatedFees, total };
};

export function srcset(image: string, size: number, rows = 1, cols = 1) {
	return {
		src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
		srcSet: `${image}?w=${size * cols}&h=${
			size * rows
		}&fit=crop&auto=format&dpr=2 2x`,
	};
}

export function flattenToQuery(obj: any, prefix = ''): Record<string, string> {
	const result: Record<string, string> = {};

	for (const key in obj) {
		// eslint-disable-next-line no-prototype-builtins
		if (!obj.hasOwnProperty(key)) continue;

		const value = obj[key];
		const prefixedKey = prefix ? `${prefix}[${key}]` : key;

		if (typeof value === 'object' && !Array.isArray(value)) {
			Object.assign(result, flattenToQuery(value, prefixedKey));
		} else if (Array.isArray(value)) {
			value.forEach((v, i) => {
				result[`${prefixedKey}[${i}]`] = v;
			});
		} else {
			result[prefixedKey] = String(value);
		}
	}

	return result;
}

export function getAuthorSubtitle(companyProfile: {roleCreator: boolean, roleVendor: boolean, isVerified: boolean, createdAt: string}, t: TFunction, locale: string) {
	let subtitle = '';
	if (companyProfile.roleCreator && companyProfile.roleVendor) {
		subtitle = t('author.creatorAndSeller');
	} else if (companyProfile.roleCreator) {
		subtitle = t('author.creator');
	} else if (companyProfile.roleVendor) {
		subtitle = t('author.seller');
	}
	if (companyProfile.isVerified) {
		subtitle += `${subtitle ? ' | ' : ''}${t('author.memberSince', {date: new Date(companyProfile?.createdAt).toLocaleDateString(locale, {year: 'numeric'})})}`;
	}
	return subtitle;
}